module.exports = __webpack_public_path__ + "img/g-ads.b7752a25.svg";